import React from "react";

import { Paragraph } from "@fronterahealth/frontera-ui-components";

interface SectionDividerProps {
  label: string;
}

export const SectionDivider: React.FC<SectionDividerProps> = ({ label }) => (
  <div className="flex mt-8 mb-6">
    <div className="border-t grow" />
    <Paragraph displayType="loud" colorType="primary" className="-mt-3 mx-4">
      {label}
    </Paragraph>
    <div className="border-t grow" />
  </div>
);
